<template>
  <div id="addrstaff">
    <!-- 考区工作人员安排 -->
    <small class="color-gray">工作任务数据需要在考务系统PC端处理</small>
  </div>
</template>

<script>
export default {
  name: "addrstaff"
};
</script>

<style scoped>
</style>